import { Api } from "@/services";

export function useCheckout() {
  const baseUrl = "/checkouts";

  const getCheckoutDefault = () => Api.get(`${baseUrl}/default`);

  return { getCheckoutDefault };
}
